import React from "react";
import OrderProduct from "./OrderProduct";
import { FormatDate } from "../../../components/FormatDate";
import FormatPrice from "../../../components/FormatPrice";
import { NavLink } from "react-router-dom";
import {
  getOfflinePaymentStatusLabel,
  getOrderPaymentMethodLabel
} from "../../payment/paymentMethodUtils";
import {
  formatRefundAwareStatus,
  getRefundAwareOrderStatus
} from "../../../utils/cancellationRefundStatus";

const OrderLayout = ({ orderDetail }) => {
  const domainType = localStorage.getItem("domainType");
  const displayStatus = getRefundAwareOrderStatus(orderDetail);
  const paymentStatusLabel = getOfflinePaymentStatusLabel(displayStatus)
    || formatRefundAwareStatus(displayStatus)
    || "Paid";
  const paymentMethodLabel = getOrderPaymentMethodLabel(
    orderDetail?.paymentMethod,
    orderDetail?.company?.operatingLocation?.code || localStorage.getItem("operatingLocationCode") || ""
  );
 

  return (
    <div className="w-full bg-white border border-gray-300 rounded-lg rounded-se-* shadow pb-4 my-4">
      {/* order header */}
      <div className="bg-gray-100 h-full flex justify-between text-gray-600 ">
        <ul
          className="flex flex-wrap uppercase text-xs font-medium text-center border-b rounded-t-lg "
          id="defaultTab"
        >
          <OrderHead
            title={"order placed"}
            value={FormatDate(orderDetail.createdDate)}
          />
          <OrderHead
            title={"total"}
            value={<FormatPrice price={orderDetail.totalAmount} />}
          />
          <OrderHead
            title={"status"}
            value={formatRefundAwareStatus(paymentStatusLabel)}
          />
          <OrderHead
            title={"payment"}
            value={paymentMethodLabel}
          />
          {domainType === "RETAIL" ? (
            <OrderHead title={"ship to"} value={"georgia"} />
          ) : (
            ""
          )}
        </ul>
        <div className="me-2">
          <div className="inline-block p-4 text-xs float-right">
            <div className="font-sans font-bold">
              ORDER # {orderDetail.number}{" "}
            </div>

            <div className="pt-2 text-sky-700 capitalize">
              <NavLink
                state={{ propData: orderDetail }}
                to={{
                  pathname: `/profile/myorders/${orderDetail._id}`,
                }}
                className="me-2 inline-block hover:text-sky-500"
              >
                view order details
              </NavLink>
              {/* This link will be enabled once we have our own payment service */}
              {/* <a href="" className="inline-block hover:text-sky-500">
                view invoice
              </a> */}
            </div>
          </div>
        </div>
      </div>

      {/* products */}
      <div
        className="bg-white border-t font-sans"
        id="about"
        role="tabpanel"
        aria-labelledby="about-tab"
      >
        {orderDetail &&
          orderDetail.lineItemList.map((prodItem) => (
            <OrderProduct
              key={
                domainType === "RETAIL"
                  ? prodItem.product._id
                  : prodItem.scheduledProduct._id
              }
              productItem={
                domainType === "RETAIL"
                  ? prodItem.product
                  : prodItem.scheduledProduct.product
              }
            />
          ))}
      </div>
    </div>
  );
};
const OrderHead = ({ title, value }) => {
  return (
    <li className="me-2">
      <div className="inline-block p-4 ">
        <div className="font-bold font-gray-500 font-sans subpixel-antialiased">
          {title}
        </div>
        <div className="pt-1 text-sm text-gray-700 font-semibold font-sans capitalize">
          {value}
        </div>
      </div>
    </li>
  );
};

export default OrderLayout;
